import React from 'react';
import { GameStateProvider } from './GameStateContext';
import AddGame2 from '../../pages/2AddGame.js';



const AddGameRoute = () => (
  <GameStateProvider>
    <AddGame2 />
  </GameStateProvider>
);

export default AddGameRoute;
